import React, { useMemo, useCallback } from 'react';
import { createUseStyles, TimePicker } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Time');

function timeToDate(time) {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
}

function formatTime(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return hours + ':' + minutes;
}

function Time({ className, ...props }) {
    const classes = useStyles();

    const placeholders = 'hh:mm';
    const classNames = classnames(classes.root, className);

    const onChange = useCallback(
        (newValue) => {
            props.onChange(newValue ? formatTime(newValue) : newValue);
        },
        [props],
    );

    const value = useMemo(
        () => (props.value ? timeToDate(props.value) : props.value),
        [props.value],
    );

    return (
        <div className={classNames}>
            <TimePicker
                labelMode="horizontal"
                isFullWidth
                {...props}
                value={value}
                onChange={onChange}
                placeholder={placeholders}
            />
        </div>
    );
}

Time.propTypes = {
    uiGrid: PropTypes.string,
};

export default React.memo(Time);
